import React from "react"
import {
    componentStyles,
    HorizontalStack,
    Text,
    useColors,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLink } from "@fortawesome/free-solid-svg-icons/faLink"

import CopiableInputEndButton from "~components/shared/copiable-input-end-button"

interface Props {
    readonly value: string
}

export default function CopiableInput({ value }: Props) {
    const styles = useStyles()

    return (
        <HorizontalStack style={styles.root}>
            <FontAwesomeIcon icon={faLink} />
            <Text style={styles.text} numberOfLines={1}>
                {value}
            </Text>
            <CopiableInputEndButton value={value} />
        </HorizontalStack>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        root: {
            backgroundColor: colors.bgColorSecondary,
            borderRadius: "md",
            paddingLeft: 3,
            paddingRight: 1,
            paddingY: 1,
        },
        text: {
            flex: 1,
        },
    })
}
